import { render, staticRenderFns } from "./PivotTable.vue?vue&type=template&id=b22c4664&scoped=true&"
import script from "./PivotTable.vue?vue&type=script&lang=js&"
export * from "./PivotTable.vue?vue&type=script&lang=js&"
import style0 from "./PivotTable.vue?vue&type=style&index=0&id=b22c4664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22c4664",
  null
  
)

export default component.exports